<template>
  <div class="header">
    <div class="logo">
      <img src="/static/img/header/logoA.png" alt="" height="80px">
    </div>
    <!-- <div class="header_control">
      <span class="menu_index">
        <el-button type="primary" @click="home">
          <i class="icon iconfont iconhome"></i>
          首页</el-button>
      </span>
      <el-dropdown>
        <span class="el-dropdown-link">
          联盟管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>联盟简介</el-dropdown-item>
          <el-dropdown-item>联盟章程</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span class="el-dropdown-link">
          联盟管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>联盟简介</el-dropdown-item>
          <el-dropdown-item>联盟章程</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span class="el-dropdown-link">
          联盟管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>联盟简介</el-dropdown-item>
          <el-dropdown-item>联盟章程</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <span class="el-dropdown-link">
          联盟管理<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>联盟简介</el-dropdown-item>
          <el-dropdown-item>联盟章程</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
    <div class="header_info_control">
      <span class="header_info">
        欢迎您：admin
      </span>
      <span class="header_out">
        <el-button type="text" @click="loginOut">
          退出
        </el-button>
      </span>
    </div>
  </div>
</template>
<script>
import { localStorage } from '@/common/util/storage';
import { mapMutations } from 'vuex';
import * as mutationsType from '@/store/mutations/type';
export default {
  data() {
    return {};
  },
  methods: {
    loginOut() {
      localStorage.remove('token');
      this.setUserInfo({});
      this.$router.push('/home');
    },
    home() {
      this.$router.push('/home');
    },
    ...mapMutations({
      setUserInfo: mutationsType.SET_USER_INFO
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/common/adminArea/header.vue